import { readVarT } from '@execonline-inc/environment';
import Intercom, { shutdown } from '@intercom/messenger-js-sdk';
import { observer } from 'mobx-react';
import { useEffect } from 'react';
import { IntercomGuestInitData } from './Types';

function IntercomGuestTooling() {
  useEffect(() => {
    readVarT('VITE_INTERCOM_APP_ID')
      .map<IntercomGuestInitData>((appId) => ({
        app_id: appId,
      }))
      .fork(() => {
        console.warn('Unable to load Intercom: Missing environment variable VITE_INTERCOM_APP_ID');
      }, Intercom);

    return shutdown;
  }, []);

  return <></>;
}

export default observer(IntercomGuestTooling);
